
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#333"}},[_c('path',{attrs:{"d":"M22.034.887H7.626c-.738 0-1.337.598-1.337 1.336v13.119c0 .737.599 1.336 1.337 1.336h17.023c.738 0 1.337-.599 1.337-1.336V4.862s-.008-.024-.008-.039a.29.29 0 00-.023-.112.378.378 0 00-.07-.104c-.007-.008-.007-.016-.015-.024L22.308 1a.393.393 0 00-.27-.116l-.004.004zm.858 3.588A.475.475 0 0122.417 4V2.212l2.252 2.263h-1.777zM21.644 1.66V4c0 .688.56 1.248 1.248 1.248h2.317v10.094a.562.562 0 01-.564.564H7.625a.565.565 0 01-.563-.564V2.223c0-.309.255-.564.564-.564h14.022-.004z"}}),_c('path',{attrs:{"d":"M11.716 6.363h9.746c.232 0 .417.186.417.417a.415.415 0 01-.417.418h-9.746a.415.415 0 01-.417-.418c0-.231.185-.417.417-.417zM13.572 8.55h7.887c.232 0 .418.186.418.418a.415.415 0 01-.418.417h-7.887a.415.415 0 01-.418-.417c0-.232.186-.417.418-.417zM14.314 10.934h7.146c.232 0 .417.185.417.417a.415.415 0 01-.417.417h-7.146a.415.415 0 01-.418-.417c0-.232.186-.417.418-.417z"}})]),_c('path',{attrs:{"d":"M6.234 19.117a6.219 6.219 0 100-12.437 6.219 6.219 0 000 12.437z","fill":"#333"}}),_c('path',{attrs:{"d":"M5.61 9.049c.168-.17.391-.26.655-.26s.483.09.656.26c.173.169.26.392.26.656 0 .263-.091.482-.26.655a.882.882 0 01-.656.26.905.905 0 01-.656-.26.882.882 0 01-.26-.655c0-.264.091-.483.26-.656zM7.873 16.522a.31.31 0 01-.314.313H5.044a.303.303 0 01-.314-.313v-.276a.31.31 0 01.314-.314l.565-.053v-3.3l-.615-.065a.316.316 0 01-.3-.314v-.247c0-.17.119-.301.276-.314l1.323-.222s.025-.013.079-.013h.342c.181 0 .313.132.313.314v4.177l.549.054c.157 0 .289.144.289.313v.26h.012-.004z","fill":"#fff"}})])
          )
        }
      }
    